var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgICircularIconOrange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.41797 12.4986L7.41797 6.47574C7.41797 6.13695 7.71178 5.8623 8.07422 5.8623C8.43666 5.8623 8.73047 6.13695 8.73047 6.47574L8.73047 12.4986C8.73047 12.8374 8.43666 13.1121 8.07422 13.1121C7.71178 13.1121 7.41797 12.8374 7.41797 12.4986Z",
    fill: "#FF5F14"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8.94971 3.5752C8.94971 4.05844 8.55796 4.4502 8.07471 4.4502C7.59146 4.4502 7.19971 4.05844 7.19971 3.5752C7.19971 3.09195 7.59146 2.7002 8.07471 2.7002C8.55796 2.7002 8.94971 3.09195 8.94971 3.5752Z",
    fill: "#FF5F14"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8 14.6667C11.6819 14.6667 14.6667 11.6819 14.6667 8C14.6667 4.3181 11.6819 1.33333 8 1.33333C4.3181 1.33333 1.33333 4.3181 1.33333 8C1.33333 11.6819 4.3181 14.6667 8 14.6667ZM8 16C12.4183 16 16 12.4183 16 8C16 3.58172 12.4183 0 8 0C3.58172 0 0 3.58172 0 8C0 12.4183 3.58172 16 8 16Z",
    fill: "#FF5F14"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgICircularIconOrange);
export default __webpack_public_path__ + "static/media/i_circular_icon_orange.5321d9c264ee0d10812c35efd28906af.svg";
export { ForwardRef as ReactComponent };